import { type FC } from "react";

import { env } from "config/env";

const Image: FC<{ source: string, alt: string, className?: string }> = ({ source, alt, className = '' }) => {
    return <img src={ `${env.REACT_APP_AWS_CLOUDFLARE}/${source}` } alt={ alt } className={ className } loading="lazy" />
}

export default Image;